module.exports = __webpack_public_path__ + "img/ZZRY_4.08091a85.jpg";